import api from '@/api/index.js'

const pos_transaction = {
  state: {
    loading: false,
    data: null,
    error: null
  },

  mutations: {
    SET_POS_TRANSACTION_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_POS_TRANSACTION: (state, data) => {
      state.data = data
      state.loading = false
    },
    SET_POS_TRANSACTION_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    LoadPosTransaction({commit}, query) {
      commit('SET_POS_TRANSACTION', null)
      commit('SET_POS_TRANSACTION_LOADING', true)
      return api.get(`pos-transactions/${query.id}`)
        .then((response) => {
          commit('SET_POS_TRANSACTION', response)
        })
        .catch((error) => {
          commit('SET_ERROR', error)
          commit('SET_POS_TRANSACTION_ERROR', error)
          commit('SET_POS_TRANSACTION_LOADING', false)
        })
    }
  }
}

export default pos_transaction
